"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Founder() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [accentHeight, setAccentHeight] = useState(0);
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const handleScroll = () => {
      const scrolled = container.scrollTop;
      const maxScroll = container.scrollHeight - container.clientHeight;
      const progress = Math.min(scrolled / maxScroll, 1);
      setAccentHeight(progress * 100);
    };
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);
  const achievements = ["Over 20 years of real estate experience", "$2B+ in completed transactions", "Specialization in land and development strategy", "Expertise in deal origination and execution", "Strategic advisory for developers and investors", "Deep understanding of entitlement and feasibility analysis"];
  return <section id="founder" className="relative min-h-screen bg-background">
      <div className="mx-auto max-w-[1440px]">
        <div className="grid lg:grid-cols-2 min-h-screen">
          {}
          <div className="relative lg:sticky lg:top-0 lg:h-screen overflow-hidden">
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/image_15fgm9dz.jpg)] bg-cover bg-center" />
            <div className="absolute inset-0 bg-linear-to-t from-dark-section/80 via-dark-section/40 to-transparent" />
            
            {}
            <div className="absolute left-12 top-0 w-[3px] bg-accent/20 h-full">
              <div className="w-full bg-accent transition-all duration-300 ease-out" style={{
              height: `${accentHeight}%`
            }} />
            </div>

            {}
            <div className="absolute bottom-12 left-12 right-12">
              <h3 className="text-white text-[14px] font-semibold tracking-[0.2em] uppercase mb-2">
                Founder & Principal
              </h3>
              <h1 className="text-white text-[56px] font-bold leading-[1.1] uppercase tracking-wider">Greg Cooper J.d.</h1>
            </div>
          </div>

          {}
          <div ref={scrollContainerRef} className="relative bg-background overflow-y-auto lg:h-screen">
            <div ref={contentRef} className={`px-8 lg:px-16 py-16 lg:py-24 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <div className="mb-8">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542976/img/image_mrbv60ym.png" alt="DealForge Real Estate Advisory" className="h-7" />
              </div>

              {}
              <div className="mb-12">
                <div className="inline-block px-4 py-2 bg-accent/10 rounded-(length:--radius-md) mb-4">
                  <span className="text-accent-dark text-[12px] font-semibold tracking-[0.15em] uppercase">
                    Leadership
                  </span>
                </div>
                <h2 className="text-foreground text-[42px] font-bold leading-[1.2] uppercase tracking-wider mb-6">
                  Strategic Vision
                </h2>
                <div className="w-16 h-[3px] bg-accent" />
              </div>

              {}
              <div className="space-y-8 mb-12">
                <p className="text-foreground text-[18px] leading-[1.7] font-light">Greg Cooper is a seasoned real estate executive and strategic deal advisor with over 20 years of experience and a law degree from the University of Texas. He specializes in land and development strategy, deal origination, and brokerage execution, guiding clients through complex transactions with an institutional approach.</p>

                <p className="text-muted-foreground text-[16px] leading-[1.7]">
                  His expertise spans the full development lifecycle, from off-market opportunity sourcing to entitlement consulting and project feasibility analysis. Greg has built a reputation for creating opportunities before transactions occur, working closely with developers, landowners, investors, and family offices.
                </p>

                <p className="text-muted-foreground text-[16px] leading-[1.7]">
                  With a deep understanding of both residential and commercial markets, Greg delivers sophisticated advisory services that go beyond traditional brokerage. His approach combines strategic insight with execution excellence, ensuring clients navigate complex real estate decisions with confidence.
                </p>
              </div>

              {}
              <div className="border-t border-border pt-12">
                <h3 className="text-foreground text-[24px] font-semibold uppercase tracking-wider mb-8">
                  Key Achievements
                </h3>
                
                <div className="space-y-6">
                  {achievements.map((achievement, i) => <div key={i} data-index={i} className="flex items-start gap-4 group">
                      <div className="flex-shrink-0 w-2 h-2 bg-accent rounded-full mt-2 group-hover:scale-125 transition-transform duration-200" />
                      <p className="text-foreground text-[16px] leading-[1.6] group-hover:text-accent-dark transition-colors duration-200">
                        {achievement}
                      </p>
                    </div>)}
                </div>
              </div>

              {}
              <div className="mt-16 p-8 bg-surface rounded-(length:--radius-md) border-l-4 border-accent">
                <p className="text-foreground text-[20px] leading-[1.6] italic font-light mb-4">
                  "We don't chase deals. We build them."
                </p>
                <p className="text-muted-foreground text-[14px] uppercase tracking-wider">
                  — Greg Cooper
                </p>
              </div>

              {}
              <div className="h-24" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}